import template from './templates/delivery-address';
import parseRenderingContext from '@utils/parse-rendering-context';
import CheckoutShipping from '../checkout/checkout-shipping.js';
import { dataProperties } from '../myVCA/manage-subscriptions';

export default class DeliveryAddress extends CheckoutShipping.extendTemplate(template) {
    constructor($originEl, context) {
        super($originEl, context, {
            checkoutFormClassList: 'bg-transparent padding-0'
        });

        this.$submitCtrl = this.$el.find('[data-control="submit"]');

        this.watch('selectedAddressValue', () => this.onAddressChange());
    }

    onAddressChange() {
        this.$submitCtrl.attr(`data-${dataProperties.vetsourceAddressId}`, this.selectedAddressInfo.AddressName);
    }
}

$(() => {
    const rootEls = document.querySelectorAll('.js-delivery-address');
    rootEls.forEach((el) => {
        const $el = $(el);
        const renderingContext = parseRenderingContext(el);

        const shipping = new DeliveryAddress($el, renderingContext);
        shipping.init();
    });
});
